import React, { useContext } from 'react'

interface IProps {
  label: string
  value: any
  className?: string
  rf?: string
  trackElement?: string
  isDisabled?: boolean
  onClick: (value: any) => void
}

/**
 * Dropdown item
 *
 *
 * @param name (string, optional) - Inner item value
 * @param label (string, required) - Item label
 * @param rf (string, optional) - Optional tracking id for automated tests
 * @param trackElement (string, optional) - User tracking track element id
 * @param onClick ((value: string, name?: string) => void, required) - On click handler
 * @param className (string, optional) - Optional css class
 *
 */
export default function DropdownItem({ label, value, rf, trackElement, onClick, className, isDisabled }: IProps) {

  const getItemClass = () => {
    const classParts: string[] = []
    if (className) {
      classParts.push(className)
    }
    if (isDisabled) {
      classParts.push('disabled')
    }

    return classParts.join(' ')
  }

  const handleClick = () => {
    onClick(value)
  }

  return (
    <li>
      <a onClick={handleClick} data-testid={rf} className={getItemClass()}>
        {label}
      </a>
    </li>
  )
}
